import { addHours, set, startOfHour } from "date-fns";

import { useConfigurationContext } from "../root/ConfigurationContext";

/** Before this hour a new task defaults to DEFAULT_MORNING_HOUR the same day. */
const WORKDAY_START_HOUR = 9;
const DEFAULT_MORNING_HOUR = 10;
/** The placeholder type of the default configuration ("Ninguno"). */
const NO_TYPE = "none";

/**
 * Default due time of a new task: the next full hour (14:20 -> 15:00,
 * 14:00 -> 15:00, 23:30 -> 00:00 the next day), or 10:00 the same day when it
 * is still before 09:00, so a task created at night is not due at 01:00.
 */
export const nextRoundHour = (now: Date = new Date()): Date =>
  now.getHours() < WORKDAY_START_HOUR
    ? set(now, {
        hours: DEFAULT_MORNING_HOUR,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
      })
    : addHours(startOfHour(now), 1);

/**
 * Default type of a new task: the first configured type that is a real one
 * (not the "none" placeholder), so the required field starts on something
 * meaningful ("Llamada" with the default configuration).
 */
export const defaultTaskType = (
  taskTypes: readonly { value: string }[],
): string =>
  taskTypes.find((type) => type.value !== NO_TYPE)?.value ??
  taskTypes[0]?.value ??
  NO_TYPE;

/** The defaults every "new task" form starts from (type and due date). */
export const useNewTaskDefaults = (): { type: string; due_date: string } => {
  const { taskTypes } = useConfigurationContext();
  return {
    type: defaultTaskType(taskTypes),
    due_date: nextRoundHour().toISOString(),
  };
};
